module.exports = __webpack_public_path__ + "img/read.bdca9c32.png";